// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EIx5gt0902rBwd7CpsDa {
  align-items: center;
  column-gap: 1rem;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/widen-library/admin/src/components/Pagination/Pagination.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb","sourcesContent":[".pagination {\n  align-items: center;\n  column-gap: 1rem;\n  display: flex;\n  justify-content: center;\n  margin-top: 1rem;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `EIx5gt0902rBwd7CpsDa`
};
export default ___CSS_LOADER_EXPORT___;
